'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { AlertCircle, ExternalLink, Users } from 'lucide-react';
import Image from 'next/image';
import { client } from '../../utils/trpc';
import LinkButton from '../common/LinkButton';
import Modal, { ModalContent, ModalHeader } from '../HOC/Modal';
type Props = {
  closeHandler: () => void;
  groupId: number;
  currentFactiiiName: string;
};
export const GroupFactiiisModal = t0 => {
  const $ = _c(64);
  const {
    closeHandler,
    groupId,
    currentFactiiiName
  } = t0;
  let t1;
  let t2;
  if ($[0] !== groupId) {
    t1 = ["factiiis", "group", groupId];
    t2 = async () => {
      const [error, data] = await client.factiiis.getGroupFactiiis.query({
        groupId
      });
      if (error) {
        throw error;
      }
      return data;
    };
    $[0] = groupId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  const t3 = Boolean(groupId);
  let t4;
  if ($[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    data: groupData,
    isLoading
  } = useQuery(t4);
  if (isLoading) {
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="flex items-center gap-2"><Users className="size-5 text-primary" /><span className="text-textPrimary">Grouped Factiiis</span></div>;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    let t6;
    if ($[8] !== closeHandler) {
      t6 = <ModalHeader closeHandler={closeHandler}>{t5}</ModalHeader>;
      $[8] = closeHandler;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    let t7;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <ModalContent><div className="text-center text-textSecondary">Loading...</div></ModalContent>;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    let t8;
    if ($[11] !== closeHandler || $[12] !== t6) {
      t8 = <Modal closeHandler={closeHandler}>{t6}{t7}</Modal>;
      $[11] = closeHandler;
      $[12] = t6;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    return t8;
  }
  if (!groupData?.group) {
    let t5;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="flex items-center gap-2"><Users className="size-5 text-primary" /><span className="text-textPrimary">Grouped Factiiis</span></div>;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    let t6;
    if ($[15] !== closeHandler) {
      t6 = <ModalHeader closeHandler={closeHandler}>{t5}</ModalHeader>;
      $[15] = closeHandler;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    let t7;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <ModalContent><div className="flex items-center justify-center gap-2 rounded-lg border border-destructive/20 bg-destructive/5 p-4 text-destructive"><AlertCircle className="size-5" /><span>Failed to load group information</span></div></ModalContent>;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    let t8;
    if ($[18] !== closeHandler || $[19] !== t6) {
      t8 = <Modal closeHandler={closeHandler}>{t6}{t7}</Modal>;
      $[18] = closeHandler;
      $[19] = t6;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    return t8;
  }
  let T0;
  let T1;
  let t10;
  let t11;
  let t12;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[21] !== closeHandler || $[22] !== currentFactiiiName || $[23] !== groupData.group.factiiis) {
    let t13;
    if ($[34] !== currentFactiiiName) {
      t13 = factiii => factiii.name !== currentFactiiiName;
      $[34] = currentFactiiiName;
      $[35] = t13;
    } else {
      t13 = $[35];
    }
    const otherFactiiis = groupData.group.factiiis.filter(t13);
    T1 = Modal;
    t11 = closeHandler;
    let t14;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <div className="flex items-center gap-2"><Users className="size-5 text-primary" /><span className="text-textPrimary">Grouped Factiiis</span></div>;
      $[36] = t14;
    } else {
      t14 = $[36];
    }
    if ($[37] !== closeHandler) {
      t12 = <ModalHeader closeHandler={closeHandler}>{t14}</ModalHeader>;
      $[37] = closeHandler;
      $[38] = t12;
    } else {
      t12 = $[38];
    }
    T0 = ModalContent;
    t9 = "space-y-4";
    let t15;
    if ($[39] !== currentFactiiiName) {
      t15 = <strong className="text-primary">{currentFactiiiName}</strong>;
      $[39] = currentFactiiiName;
      $[40] = t15;
    } else {
      t15 = $[40];
    }
    const t16 = <div className="text-sm text-textPrimary">{t15} is part of a group with{" "}<strong>{otherFactiiis.length} other factiii{otherFactiiis.length !== 1 ? "s" : ""}</strong>.</div>;
    let t17;
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = <div className="mt-2 text-sm text-textSecondary">When you tag one factiii from this group, any other factiiis from the same group on this post will be retired.</div>;
      $[41] = t17;
    } else {
      t17 = $[41];
    }
    if ($[42] !== t16) {
      t10 = <div className="rounded-lg border border-ds-border-standard bg-background-secondary p-4">{t16}{t17}</div>;
      $[42] = t16;
      $[43] = t10;
    } else {
      t10 = $[43];
    }
    t7 = "space-y-3";
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <h4 className="text-sm font-semibold text-textPrimary">Other factiiis in this group:</h4>;
      $[44] = t8;
    } else {
      t8 = $[44];
    }
    t5 = "space-y-2";
    t6 = otherFactiiis.map(_temp);
    $[21] = closeHandler;
    $[22] = currentFactiiiName;
    $[23] = groupData.group.factiiis;
    $[24] = T0;
    $[25] = T1;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
  } else {
    T0 = $[24];
    T1 = $[25];
    t10 = $[26];
    t11 = $[27];
    t12 = $[28];
    t5 = $[29];
    t6 = $[30];
    t7 = $[31];
    t8 = $[32];
    t9 = $[33];
  }
  let t13;
  if ($[45] !== t5 || $[46] !== t6) {
    t13 = <div className={t5}>{t6}</div>;
    $[45] = t5;
    $[46] = t6;
    $[47] = t13;
  } else {
    t13 = $[47];
  }
  let t14;
  if ($[48] !== t13 || $[49] !== t7 || $[50] !== t8) {
    t14 = <div className={t7}>{t8}{t13}</div>;
    $[48] = t13;
    $[49] = t7;
    $[50] = t8;
    $[51] = t14;
  } else {
    t14 = $[51];
  }
  let t15;
  if ($[52] !== t10 || $[53] !== t14 || $[54] !== t9) {
    t15 = <div className={t9}>{t10}{t14}</div>;
    $[52] = t10;
    $[53] = t14;
    $[54] = t9;
    $[55] = t15;
  } else {
    t15 = $[55];
  }
  let t16;
  if ($[56] !== T0 || $[57] !== t15) {
    t16 = <T0>{t15}</T0>;
    $[56] = T0;
    $[57] = t15;
    $[58] = t16;
  } else {
    t16 = $[58];
  }
  let t17;
  if ($[59] !== T1 || $[60] !== t11 || $[61] !== t12 || $[62] !== t16) {
    t17 = <T1 closeHandler={t11}>{t12}{t16}</T1>;
    $[59] = T1;
    $[60] = t11;
    $[61] = t12;
    $[62] = t16;
    $[63] = t17;
  } else {
    t17 = $[63];
  }
  return t17;
};
function _temp(factiii_0) {
  return <div key={factiii_0.id} className="flex items-center gap-3 rounded-lg border border-ds-border-standard bg-background-secondary p-3 transition-all hover:bg-background-light">{factiii_0.avatar ? <Image src={factiii_0.avatar} alt={factiii_0.name} width={40} height={40} className="rounded-full" /> : <div className="flex size-10 items-center justify-center rounded-full bg-primary/10"><span className="text-sm font-semibold text-primary">{factiii_0.name.charAt(0).toUpperCase()}</span></div>}<div className="min-w-0 flex-1"><div className="font-emphasis text-textPrimary">{factiii_0.name}</div><div className="text-sm text-textSecondary">by @{factiii_0.username}{factiii_0.spaceSlug && <span className="ml-1">in /{factiii_0.spaceSlug}</span>}</div>{factiii_0.description && <div className="mt-1 text-sm text-textSecondary/70">{factiii_0.description}</div>}</div><LinkButton href={`/fids/${factiii_0.id}`} variant="CLEAR" icon={<ExternalLink size={16} />} tooltip={`Visit ${factiii_0.name}`} /></div>;
}